import { Degree } from '@/models/Degree';
import { IMutations } from './interfaces/IMutations';
import { IState } from './interfaces/IState';
import { Organisation } from '@/models/Organisation';

export class Mutations implements IMutations {
	private readonly state: IState;

	public constructor(state: IState) {
		this.state = state;
	}

	public setDegree(degree: Degree): void {
		this.state.degree = degree;
	}

	public setOrganisations(organisations: readonly Organisation[]): void {
		this.state.organisations = organisations;
	}

	public setTotalSearchResults(totalSearchResults: number): void {
		this.state.totalSearchResults = totalSearchResults;
	}

	public setPageNumber(pageNumber: number): void {
		this.state.currentPage = pageNumber;
	}

	public reset(): void {
		this.state.degree = Degree.master;
		this.state.organisations = [];
		this.state.totalSearchResults = 0;
		this.state.currentPage = 1;
	}
}
